import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "918076222021";
const DEFAULT_MESSAGE = "Hi, I'm interested in your services. Please share more details.";

export default function FloatingWhatsApp() {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[hsl(142,70%,40%)] text-white shadow-lg transition-transform hover:scale-110 hover:bg-[hsl(142,70%,35%)]"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
